import { getDefaultConfig } from '../base.js';

const envConfig = {
    subDomain: 'certification',
    rootDomain: 'casino.cert.canada.fndl.dev',
    apis: {
        TransactionHistory: {
            baseUrl: 'https://api.statePlaceholder.crt.canada.casino.fndl.dev'
        },
        SiteWideJackpotClient: {
            host: 'api.statePlaceholder.crt.canada.casino.fndl.dev'
        },
        MdsClient: {
            baseUrl: 'mds.statePlaceholder.crt.canada.casino.fndl.dev'
        }
    },
    services: {
        braze: {
            key: '8e6446fc-2d04-4b49-a241-cef9e4f346ce',
            product: 'FD-CASINO'
        },
        smartBanner: {
            id: 1506229470
        }
    },
    geolocation: {
        country: 'us'
    },
    otherCountries: [
        {
            countryCode: 'usa',
            link: 'https://casino.fanduel.com'
        }
    ]
};

export const config = getDefaultConfig(envConfig);
